import difference from 'lodash/difference';

import { HTML_ALLOWED_ATTRIBUTES, HTML_ALLOWED_TAGS } from '@lumapps/widget-html/constants';

/** Maximum string length to translate when using google translate api v2
 * @see https://cloud.google.com/translate/quotas#content-limit
 */
export const GOOGLE_TRANSLATE_V2_MAX_LENGTH = 100000;

/** Maximum string length to translate when using google translate api v3
 * @see https://cloud.google.com/translate/quotas#content-limit
 */
export const GOOGLE_TRANSLATE_V3_MAX_LENGTH = 30000;

/** This FF enable google translate api v3 on a customer */
export const ADVANCED_END_USER_TRANSLATION_FF = 'advanced_end_user_translation';

/** List of html tags to allow in auto translation */
export const AUTO_TRANSLATION_HTML_ALLOWED_TAGS = difference(
    HTML_ALLOWED_TAGS,
    // Exclude tags that are not necessary in auto translation
    ['script', 'style'],
);

/** List of html attributes to allow in auto translation */
export const AUTO_TRANSLATION_HTML_ALLOWED_ATTRIBUTES = [...HTML_ALLOWED_ATTRIBUTES];
